<template>
<div id="kpu-view">
  <vx-card ref="listCard" :title="$t('KPU.Title')"  class="kpu-list-filters mb-3" title-color="black" refresh-content-action @refresh="getKpus" :stats-card-action="$auth.checkRoles(['KPUCollaborators', 'Admin'])" @stats="openReport" >
    <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      :context="context"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="kpuList"
      :rowClassRules="rowClassRules"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableCellChangeFlash="false"
      :enableRtl="$vs.rtl"></ag-grid-vue>
  </vx-card>
</div>

</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";
import router from '../../../router'
import moduleKpu from "./store/moduleKpu.js";

import KpuActionsCellRenderer from './components/KpuActionsCellRenderer.vue'
import KPUStatusEnum from './KPUStatusEnum.js'

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    KpuActionsCellRenderer
  },
  data() {
    return {
      isMounted: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.id;
        }
      },
      rowClassRules: {
        'kpu-inprogress': 'data.isInProgress'
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'id',
          width: 150,
          editable: false,
          sortable: false,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          cellRendererFramework: Vue.extend(KpuActionsCellRenderer)
        },
        {
          headerName: this.$t('KPU.Project'),
          field: "projectName",
          filter:'agTextColumnFilter',
          width: 200
        },
        {
          headerName: this.$t('KPU.ProjectLeader'),
          field: "projectLeader",
          width: 200,
          filter:'agTextColumnFilter',
          valueGetter: (params) => {
            const user = this.$store.state.kpu.projectLeaders.find(p => p.userPrincipalName === params.data.projectLeader);
            if (user)
              return user.displayName;

            return "";
          }
        },
        { 
          headerName: this.$t('KPU.KPUStatus.' + KPUStatusEnum.Ok),
          field: "statusCount",
          width: 175,
          filter:'agNumberColumnFilter',
          valueGetter: (params) => {
            return this.getStatusCount(params, KPUStatusEnum.Ok);
          }
        },
        { 
          headerName: this.$t('KPU.KPUStatus.' + KPUStatusEnum.Warning),
          field: "statusCount",
          width: 175,
          filter:'agNumberColumnFilter',
          valueGetter: (params) => {
            return this.getStatusCount(params, KPUStatusEnum.Warning);
          }
        },
        { 
          headerName: this.$t('KPU.KPUStatus.' + KPUStatusEnum.BehindTarget),
          field: "statusCount",
          width: 175,
          filter:'agNumberColumnFilter',
          valueGetter: (params) => {
            return this.getStatusCount(params, KPUStatusEnum.BehindTarget);
          }
        },
        {
          headerName: this.$t('KPU.LatestUpdate'),
          field: "latestUpdate",
          width: 175,
          filter:'agDateColumnFilter',
          valueFormatter: this.formatDateTime
        },
        {
          headerName: this.$t('KPU.ModifiedBy'),
          field: "modifiedBy",
          width: 200,
          filter:'agTextColumnFilter'
        }
      ],
      components: {
        KpuActionsCellRenderer
      }
    };
  },

  computed: {
    kpuList() {
      return this.$store.state.kpu.kpus;
    }
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    
    if (this.$store.state.kpu.projectLeaders.length === 0) {
      this.$vs.loading();

      this.$store.dispatch("kpu/fetchProjectLeaders").then(() => {
        if (!this.isMounted) {
          this.$refs.listCard.refreshcard();
        }

        this.isMounted = true;

      }).finally(() => {
        this.$vs.loading.close();
      })
    } 
    else {
      if (!this.isMounted) {
        this.$refs.listCard.refreshcard();
      }

      this.isMounted = true;
    }
  },

  created() {
    if (!moduleKpu.isRegistered) {
      this.$store.registerModule("kpu", moduleKpu);
      moduleKpu.isRegistered = true;
    }
  },
  methods: {
    openReport() {
      router.push({ name: 'BSG-kpu-report' });
    },
    formatDateTime(params) {
      if (params.value === '0001-01-01T00:00:00')
        return "";

      return this.$options.filters.toDate(params.value);
    },
    getStatusCount(params, status) {
      if (params.data.statusCount !== null) {
        const element = params.data.statusCount[status];
        if (element) {
          return element;
        }
        else {
          return 0;
        }
      }
      else {
        return 0;
      }
    },
    editData(data) {
      router.push({ name: 'BSG-kpu-kpu-edit', params: { editData: data } });
    },
    viewData(data) {
      router.push({ name: 'BSG-kpu-paginatedreport-single',  query: { keyProjectId: data.keyProjectId } });
    },
    deleteData(id) {
      this.$store.dispatch("kpu/removeKPU", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("KPU.KPUDeleted")
          });
          this.$refs.listCard.refreshcard();
        });
    },
    getKpus() {
      this.$store.dispatch("kpu/fetchKPUListItems").then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });   
    },

    submitStatement(id) {
      this.$webApi.post('cashflow/kpu/submit/' + id)
        .then((response) => {
          if (response.status === 200) {
          
            this.$vs.notify({
              color: "success",
              title: this.$t("Success"),
              text: this.$t("KPU.SubmitSuccess")
            });

            this.$refs.listCard.refreshcard();

          }
        }).catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss">
#kpu-view {
  .kpu-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.comparisonPopup {
    .vs-popup {
      width: 1400px !important;
    }
  } 

.kpu-inprogress {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #ffcc00 !important;
}

.kpu-submitted {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #339900 !important;
}
</style>
